const styles = theme => ({
    cumulativeReturnChart: {
        minHeight: 150,
        height: 350
    }
})

export default styles;